import { Directive, Input, ElementRef, ViewContainerRef, OnInit, AfterViewInit, TemplateRef, OnChanges, SimpleChanges, forwardRef, HostListener   } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR  } from '@angular/forms'

import { PermissionService, SharedService, GATrackerService } from './service';
import { IGATrackerEventConfig, IGATrackerEventParamsConfig, PermissionCheck } from './interface';

import * as _ from 'lodash';
import { CdnBaseURL, TextPlainPipe } from './pipe';
import { NgModel } from '@angular/forms';

declare const jQuery: any;
declare const $: any;

@Directive({
  selector: '[permissionCheck],[hasPermission]',
})
export class PermissionDirective {
  public $el: any;
  public permissionCheck: PermissionCheck;
  constructor(
    public permissionService: PermissionService,
    // public sharedService: SharedService,
    public el: ElementRef,
    public template: TemplateRef<any>,
    public container: ViewContainerRef,

  ) {
    this.$el = jQuery(el.nativeElement);
  }

  @Input() set hasPermission(perm: PermissionCheck) {
    this.permissionCheck = perm || {};
    this.updateView();
  }

  public updateView() {
    if (!this.permissionService.check(this.permissionCheck)) {
      this.container.clear();
      this.$el.remove();
    } else {
      this.container.createEmbeddedView(this.template);
    }
  }



}

// tslint:disable-next-line:max-classes-per-file
@Directive({
  selector: '[ga-tracker]',
})
export class GoogleAnalyticsTrackerDirective implements OnInit, AfterViewInit {
  public $el: any;
  // tslint:disable-next-line:no-input-rename
  @Input('ga-tracker') public gaTrackerEventConf: IGATrackerEventConfig;
  @Input() public trackTrigger: string;
  @Input() public trackAction: string;
  @Input() public trackParams: IGATrackerEventParamsConfig;
  constructor(
    public el: ElementRef,
    public window: Window,
    public gaTrackerService: GATrackerService,
  ) {
    this.$el = jQuery(el.nativeElement);
    console.debug('[GATrackerDirective] constructor > ', this.window['gtag']);
  }

  // tslint:disable-next-line:no-empty
  public ngOnInit() {
  }

  public ngAfterViewInit(): void {
    this.gaTrackerEventConf = this.gaTrackerEventConf || {};
    this.gaTrackerEventConf.trackAction = this.trackAction || this.gaTrackerEventConf.trackAction || 'click';
    this.gaTrackerEventConf.trackTrigger = this.trackTrigger || this.gaTrackerEventConf.trackTrigger;
    this.gaTrackerEventConf.trackParams = this.trackParams || this.gaTrackerEventConf.trackParams;
    console.debug('[GATrackerDirective] el#%s conf', this.$el.attr('id'), this.gaTrackerEventConf);
    if (this.gaTrackerEventConf.trackTrigger) {
      setTimeout(() => {
        this.$el.on(this.gaTrackerEventConf.trackTrigger, (e) => {
          this.gaTrackerService.trackEvent(this.gaTrackerEventConf);
        });
      }, 500);
    }
  }
}

// tslint:disable-next-line:max-classes-per-file
@Directive({
  selector: 'img:not([ignore-cdn-mod])',
})
export class ImageDirective implements OnChanges {
  public $el: any;
  // tslint:disable-next-line:no-input-rename
  @Input('src') public url: string;
  constructor(
    public el: ElementRef,
    public window: Window,
  ) {
    this.$el = jQuery(el.nativeElement);
  }

  public applyCdnBaseUrl() {
    const fullURL = new CdnBaseURL().transform(this.url);
    if (fullURL !== this.url) {
      this.$el.attr('src', fullURL.concat((fullURL.indexOf('?') > -1 ? '&' : '?'), `v${VERSION.full}`));
    } else {
      this.$el.attr('src', this.url);
    }
    // console.debug('[ImageDirective] old %s new %s', this.url, this.$el.attr('src'));
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.url) {
      this.applyCdnBaseUrl();
    }
  }
}

// tslint:disable-next-line:max-classes-per-file
@Directive({
  selector: '[InputSafety]',
  // selector: `input[stripHTML]:visible:not([ignore-strip-html-tags])`,
  providers: [NgModel]
})
export class InputSafetyDirective implements OnInit, OnChanges {
  private $el: any;
  // tslint:disable-next-line:no-input-rename
  constructor(
    el: ElementRef,
    private window: Window,
    private model: NgModel
  ) {
    this.$el = jQuery(el.nativeElement);
  }

  private updateModel(value){
    const canBeReduced = TextPlainPipe.canBeReduced(value);
    if(canBeReduced){
      this.$el.attr("data-not-safe-value", value);
      value = (new TextPlainPipe).transform(value);
      setTimeout(() => {
        if(this.model.update.observers.length>0){this.model.update.emit(value);}
        else {this.$el.val(value);}
      
      });
    }
    this.$el.attr("data-safe-value", value);
  }

  public ngOnInit() {
    this.model.valueChanges.subscribe((value) => {
      this.updateModel(value);
    });

    this.$el.on('blur paste', (e)=> {
      setTimeout(() => this.updateModel(this.$el.val()));
    });

    /* Inform ng model for any new change happened */
    // this.$el.bind("customEvent", function (someNewValue) {
    //   this.model.update.emit(someNewValue);
    // });
  }

  public ngOnChanges(changes: SimpleChanges) {    
  }
}


export const COMMON_DIRECTIVES = [
  PermissionDirective,
  GoogleAnalyticsTrackerDirective,
  ImageDirective,
  InputSafetyDirective
  
];



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/common/directive.ts